import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Lodinging from "../components_root/loading";
import Error_page from './error';
import Cookies from "js-cookie";
import Properties_root from '../properties_root/properties'; 
import Phonebook_Contact from '../phonebook_root/phonebook-contact';
import Home_page from "../home_root/home";
export default function Idpage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [phonebookdata, setphonebookdata] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setphonebookdata(null);
   
        setError(false); 

            // Check in feedsdata
        const phonebookQuery = query(collection(db, "phonebook"), where("uid", "==", id));
        const phonebookSnap = await getDocs(phonebookQuery);
        if (!phonebookSnap.empty) {
          const doc = phonebookSnap.docs[0].data();
          if (doc?.status === true) {
            // document.title = doc.title + "| EditorTask.com";
            setphonebookdata({ ...doc, uid: phonebookSnap.docs[0].id });
          }
        }
      
      } catch (err) {
        console.error("Error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchData();
  }, [id]);

  // 🔁 Render Logic
  if (loading) return <div className="container_roots"><Lodinging /></div>;
  if (phonebookdata) return <Phonebook_Contact data={phonebookdata} />;
  if (error) return <Error_page />; 

  return <Home_page/>;
}
